import { render, staticRenderFns } from "./licenseDoc.vue?vue&type=template&id=c5c987c8&scoped=true&"
import script from "./licenseDoc.vue?vue&type=script&lang=js&"
export * from "./licenseDoc.vue?vue&type=script&lang=js&"
import style0 from "./licenseDoc.vue?vue&type=style&index=0&id=c5c987c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c987c8",
  null
  
)

export default component.exports